const cleanIdentifier = (value, maximumLength = 160) => {
  const customString = value && typeof value === 'object' &&
    typeof value.toString === 'function' &&
    value.toString !== Object.prototype.toString
    ? value.toString()
    : '';
  const candidate = value && typeof value === 'object'
    ? value._id || value.id || customString
    : value;
  return String(candidate || '').trim().slice(0, maximumLength);
};

/**
 * Client correlation hints for the durable meeting-chat audit trail.
 *
 * Deliberately excluded: user id, name, role, recipient identity and every
 * authorization flag. The server must derive actor/recipient information
 * from the authenticated admitted socket and validate/overwrite these room
 * identifiers against its own Room document.
 */
export const buildMeetingChatAuditContext = (room = {}, sessionId = '') => {
  const timetable = room.timetableMetadata || {};
  const sharedTimetableIds = (Array.isArray(timetable.sharedTimetableIds)
    ? timetable.sharedTimetableIds
    : [])
    .map((value) => cleanIdentifier(value))
    .filter(Boolean)
    .slice(0, 20);

  return {
    version: 1,
    roomId: cleanIdentifier(room.roomId),
    meetingId: cleanIdentifier(room._id || room.id || room.meetingId),
    meetingType: cleanIdentifier(room.meetingType, 40),
    meetingKind: cleanIdentifier(room.meetingKind, 40),
    sessionId: cleanIdentifier(sessionId),
    timetableId: cleanIdentifier(timetable.timetableId),
    sharedTimetableIds,
    courseId: cleanIdentifier(timetable.courseId),
  };
};
